module.exports = __webpack_public_path__ + "img/behance.9daeb567.svg";